






















import { computed, defineComponent, onMounted, ref } from '@vue/composition-api';

import _ from 'lodash';
import smh from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import guideHandler from '../../Workbench/composition/guideHandler';

export default defineComponent({
  setup(props, context) {
    const vm = context.root;
    const store = vm.$store;
    const isGuideShowing = ref(false);
    const shouldShowGuide = computed(() => {
      const { isMobile, isMobileStyle } = store.getters;
      if (isMobile || isMobileStyle) return false;
      const showGuide = !store.getters.noviceGuidance?.collaborationSpaceGuides?.hideShareGuide;
      if (showGuide) {
        return true;
      }
      return false;
    });
    const { methods: guideMethods } = guideHandler();
    const methods = {
      async didClickConfirmButton() {
        isGuideShowing.value = false;
      },
    };

    onMounted(async () => {
      if (_.isEmpty(store.getters.noviceGuidance)) {
        await guideMethods.queryNoviceGuidance();
      }
      // 需要展示
      if (shouldShowGuide.value) {
        isGuideShowing.value = true;
        // 展示了就马上设置标记位
        const opt = { ...store.getters.noviceGuidance };
        opt.collaborationSpaceGuides = { hideShareGuide: true };
        try {
          await smh.userAPI.createNoviceGuidance(opt);
          store.commit('setNoviceGuidance', opt);
        } catch (e: any) {
          tips.error(e as MsgError);
        }
      }
    });

    return {
      methods,
      isGuideShowing,
    };
  },
});
